import { css } from "styled-components";
// Foundations designers are onboard with this deviation and we intentionally want
// this typography to be 16px and 24px line-height, please don't touch :)
export var mobileTypographyDeviation = css([
    "font-size:16px;line-height:24px;"
]);
